import {Component} from '@angular/core';

@Component({
    selector: 'app-tasks-archive',
    templateUrl: './tasks-archive.component.html',
    styleUrl: './tasks-archive.component.scss'
})
export class TasksArchiveComponent {

}
